import { useContext } from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';
import { Plural, Trans } from '@lingui/macro';
import { IoMdAddCircleOutline } from 'react-icons/io';

import { CoreContext } from '../../../context/CoreContext';
import useReadProductCustomWording from '../../../hooks/useReadVocabulary';
import { BOTTOM_ROUNDED_CONTAINER_PROPS } from '../../../utils/styleUtil';
import ButtonAdd from '../../generic/button/ButtonAdd';
import ContainerPlural from '../../generic/layout/ContainerPlural';
import VerticalStack from '../../generic/layout/VerticalStack';

const VariantLinesContainer = ({ canAddVariant, onVariantAdd, placesAvailable, placesMax, ...props }) => {
  const { coreData } = useContext(CoreContext);
  const { show_nb_remaining_tickets: showNbPlaces } = coreData.booking_engine;

  const productCustomWording = useReadProductCustomWording();

  const btnAddProps = {
    onClick: onVariantAdd,
    icon: IoMdAddCircleOutline,
    addText: true,
  };

  const placesTextProps = {
    fontSize: '11px',
    fontStyle: 'italic',
  };

  if (placesAvailable === 0) {
    btnAddProps['isDisabled'] = true;
    btnAddProps['color'] = placesTextProps['color'] = 'red';
  }

  return (
    <Box bg="brand.background_secondary" p="8px" {...BOTTOM_ROUNDED_CONTAINER_PROPS}>
      <VerticalStack>
        {props.children}

        {placesMax !== 1 && (
          <Flex justifyContent="center" alignItems="center">
            {canAddVariant && (
              <Box>
                <ButtonAdd {...btnAddProps}>
                  {productCustomWording.participant && (
                    <>
                      <Trans>Add:</Trans> {' ' + productCustomWording.participant}
                    </>
                  )}
                  {!productCustomWording.participant && <Trans>Add</Trans>}
                </ButtonAdd>
              </Box>
            )}

            {placesAvailable !== null && showNbPlaces && (
              <Text {...placesTextProps} as="span">
                {'('}
                <ContainerPlural value={placesAvailable} style={{ display: 'inline' }}>
                  <Plural value={placesAvailable} one="place available" other="places available" />
                </ContainerPlural>
                {')'}
              </Text>
            )}
          </Flex>
        )}
      </VerticalStack>
    </Box>
  );
};

export default VariantLinesContainer;
